import { differenceInDays } from 'date-fns';
import { matchPath, useLocation } from 'react-router';

import { VerifyPhoneNumber } from '#src/components/user/VerifyPhoneNumber/index.tsx';
import { CONFIRM_EMAIL } from '#src/constants/__generated__/routes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { EmailVerificationDialog } from '#src/contexts/restrictedAccess/EmailVerificationDialog/index.tsx';
import { useRestrictedAccessContext } from '#src/contexts/restrictedAccess/index.ts';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';
import { useSkipOneDayEmailVerificationLatency } from '#src/hooks/useSkipOneDayEmailVerificationLatency.ts';

export const RestrictedAccessModals = () => {
  const { currentUser } = useCurrentUserContext();
  const { pathname } = useLocation();
  const { isMobileApp } = useIsMobileApp();

  const skipOneDayEmailVerificationLatency =
    useSkipOneDayEmailVerificationLatency();
  const { showRestrictedAccess, setShowRestrictedAccess } =
    useRestrictedAccessContext();

  const displayVerifyEmail =
    currentUser &&
    (skipOneDayEmailVerificationLatency ||
      differenceInDays(new Date(), currentUser.createdAt) > 1) &&
    !currentUser.confirmed &&
    // on mobile apps we have the notifs for reactivation
    // so we don't need to force email verification
    !isMobileApp;

  if (
    (displayVerifyEmail || showRestrictedAccess === 'email') &&
    !matchPath(CONFIRM_EMAIL, pathname)
  ) {
    return (
      <EmailVerificationDialog
        closable={!displayVerifyEmail}
        onClose={() => setShowRestrictedAccess(undefined)}
      />
    );
  }
  if (showRestrictedAccess === 'phone')
    return (
      <VerifyPhoneNumber onCancel={() => setShowRestrictedAccess(undefined)} />
    );

  return null;
};
